//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class PracticeLogSummaryDisplayItem extends ItemBase {
    DaysPracticed: number = 0;     // OBSOLETE - Use only for compatibility
    MinutesPracticed: number = 0;
    DailyAverageMinutesPracticed: number = 0;     // OBSOLETE - Use only for compatibility
    SessionAverageMinutesPracticed: number = 0;
    SessionsPracticed: number = 0;
    StudentID: string | null = null;

    constructor(initializer?: Partial<PracticeLogSummaryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PracticeLogSummaryDisplayItem";
}
